import React from 'react';

const SuccessPopup = ({onClose,message}) => {
  return (
    <div className="popup">
    <div className="popup-content">
      <div className="text-end"> 
      <button  className="bg-transparent border-0" onClick={onClose}><i className="bi bi-x-circle"></i></button>
      </div>
      <div className="text-center mt-2">
        <p className="mb-0 text-success ev-fs-30"><i className="bi bi-check2-circle"></i></p>
        <p className="ev-fs-12 ev-bold-reg">{message}</p>
      </div>
    </div>
  </div>
  );
};

export default SuccessPopup;